import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getInventory } from "../../api/apiInventory";

export const useGetInventory = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["inventory", params, i18next.language],
        queryFn: () => getInventory(params),
        keepPreviousData: true,
    });

    const root = data?.data;
    let stocks = [];
    let meta = data?.meta;
    if (Array.isArray(root)) {
        stocks = root;
    } else if (root && Array.isArray(root.data)) {
        stocks = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        stocks,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: stocks.length },
        refetch,
    };
};
